import classNames from 'classnames';

export const CustomSwitch = ({
  options,
  onSelect,
  value,
}: {
  options: { value: number; label: string }[];
  onSelect: (label: string) => void;
  value?: string;
}) => {
  const activeIndex = options.find(o => o.label === value)?.value ?? options[0].value;

  return (
    <div className="switch-options-row" data-testid="switch-options-row">
      {options?.map(option => (
        <button
          key={option.value}
          className={classNames('switch-option', {
            active: activeIndex === option.value,
          })}
          onClick={() => onSelect(option.label)}
        >
          <span className="oath-utility capitalize">{option.label}</span>
        </button>
      ))}
    </div>
  );
};
